import { cn } from '@/lib/utils';
export const TileHoverOverlayButton = ({
  show,
  label = 'View'
}: {
  show: boolean;
  label?: string;
}) => <div aria-hidden="true" className={cn('absolute flex h-full w-full items-center justify-center bg-black/60', 'transition-opacity duration-200 ease-in-out', show ? 'opacity-100' : 'pointer-events-none opacity-0')} data-sentry-component="TileHoverOverlayButton" data-sentry-source-file="index.tsx">
    <div className="flex h-8 items-center justify-center rounded-full border border-pink-500 border-solid bg-black/60 px-4 font-sans font-semibold text-sm text-white lg:h-10 lg:text-base dark:text-white">
      {label}
    </div>
  </div>;